const topics = [
  { name: '流浪地球3', heat: '9.8万讨论', trend: 'up', color: 'accent' },
  { name: '暑期档电影', heat: '7.2万讨论', trend: 'up', color: 'primary' },
  { name: '4K蓝光画质', heat: '5.6万讨论', trend: 'up', color: 'accent' },
  { name: '华语电影推荐', heat: '4.9万讨论', trend: 'up', color: 'primary' },
  { name: '封神第二部', heat: '4.3万讨论', trend: 'new', color: 'accent' },
  { name: '豆瓣高分', heat: '3.8万讨论', trend: 'stable', color: 'primary' },
  { name: '悬疑片单', heat: '3.2万讨论', trend: 'up', color: 'accent' },
  { name: '科幻巨制', heat: '2.9万讨论', trend: 'up', color: 'primary' },
  { name: '经典港片', heat: '2.5万讨论', trend: 'stable', color: 'accent' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-2 h-6 md:h-7 rounded-full bg-primary-500"></span>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50">热门话题</h2>
        </div>
        <p className="text-sm text-foreground-400 mb-8 md:mb-10">影迷们正在热议的电影话题，快来加入讨论</p>

        <div className="flex flex-wrap gap-2 md:gap-3">
          {topics.map((item, i) => (
            <a
              key={i}
              href="#topics"
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer transition-all ${
                item.color === 'accent'
                  ? 'border-background-200/40 bg-background-100 hover:border-accent-500/40 hover:bg-accent-500/10'
                  : 'border-background-200/40 bg-background-100 hover:border-primary-500/40 hover:bg-primary-500/10'
              }`}
            >
              <span
                className={`text-sm font-medium ${
                  item.color === 'accent'
                    ? 'text-foreground-100 group-hover:text-accent-400'
                    : 'text-foreground-100 group-hover:text-primary-400'
                } transition-colors`}
              >
                #{item.name}
              </span>
              <span className="text-[11px] text-foreground-500">{item.heat}</span>
              {item.trend === 'up' && (
                <i className="ri-arrow-up-line text-accent-400 text-xs"></i>
              )}
              {item.trend === 'new' && (
                <span className="px-1 py-0.5 rounded text-[9px] font-bold bg-primary-500/20 text-primary-400">NEW</span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}